var map = {
	"./logo_chatdesk.svg": 218,
	"./logo_customerio.svg": 521,
	"./logo_facebook.svg": 276,
	"./logo_freshdesk.svg": 346,
	"./logo_frontapp.svg": 347,
	"./logo_gladly.svg": 348,
	"./logo_gorgias.svg": 349,
	"./logo_helpscout.svg": 350,
	"./logo_instagram.svg": 277,
	"./logo_kustomer.svg": 351,
	"./logo_salesforce.svg": 522,
	"./logo_shopify.svg": 278,
	"./logo_tiktok.svg": 279,
	"./logo_tiktokads.svg": 523,
	"./logo_trustpilot.svg": 524,
	"./logo_twitter.svg": 352,
	"./logo_whistle.svg": 353,
	"./logo_youtube.svg": 525,
	"./logo_zendesk.svg": 219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2121;